export default "__VITE_ASSET__CRSDf020__"